import { gsap } from 'gsap'

const init = () => {
  const navAccordionElms = document.querySelectorAll('.js-navAccordion');

  navAccordionElms.forEach((elm) => {
    const panel = elm.nextElementSibling;

    // リンクを無効化
    elm.addEventListener('click', (event) => {
      if(window.matchMedia("(max-width: 960px)").matches) {
        // event.preventDefault();
        const panelHeight = panel.scrollHeight;
        elm.classList.toggle('is-open');
        if (elm.classList.contains('is-open')) {
          gsap.to(panel, {
            height: panelHeight,
            duration: 0.25,
            ease: 'power1.inOut',
          });
        } else {
          gsap.to(panel, {
            height: 0,
            duration: 0.25,
            ease: 'power1.inOut',
          });
        }

        // navAccordionElms.forEach((otherElm) => {
        //   if (otherElm !== elm) {
        //     const otherPanel = otherElm.nextElementSibling;
        //     if (otherElm.classList.contains('is-open')) {
        //       otherElm.classList.remove('is-open');
        //       gsap.to(otherPanel, {
        //         height: 0,
        //         duration: 0.25,
        //         ease: 'power1.inOut',
        //       });
        //     }
        //   }
        // });
      }
    });
  });
}

const resizeW = () => {
  const navAccordionElms = document.querySelectorAll('.js-navAccordion');

  navAccordionElms.forEach((elm) => {
    const panel = elm.nextElementSibling;
    if(window.matchMedia("(min-width: 961px)").matches) {
      // PCサイズの場合、パネルを開いた状態にする
      elm.classList.remove('is-open');
      panel.style.height = 'auto';
    } else {
      // SPサイズの場合、パネルを閉じた状態にする
      if(!elm.classList.contains('is-open')) {
        panel.style.height = 0;
      } else {
        const panelHeight = panel.scrollHeight;
        panel.style.height = panelHeight + 'px';
      }
    }
  });
}


export {
  init,
  resizeW
}